export default __webpack_public_path__ + "images/0xc778417e063141139fce010982780140aa0cd5ab.png";